import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock, mergeProps as _mergeProps, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1c6943b6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex flex-xl-row flex-lg-row flex-column-reverse home my-5" }
const _hoisted_2 = { class: "d-flex flex-column justify-center align-center" }
const _hoisted_3 = { class: "d-flex justify-center" }
const _hoisted_4 = {
  key: 1,
  class: "d-flex justify-xl-center align-xl-center justify-lg-center align-lg-center flex-column no-invoice ma-10"
}
const _hoisted_5 = { class: "d-flex justify-xl-center align-xl-center justify-lg-center align-lg-center" }
const _hoisted_6 = { class: "text-center d-flex justify-center align-center" }
const _hoisted_7 = { class: "d-flex flex-column justify-center align-center" }
const _hoisted_8 = { class: "header" }
const _hoisted_9 = { class: "d-flex justify-center" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { key: 1 }
const _hoisted_12 = { class: "d-flex flex-column justify-center align-center" }
const _hoisted_13 = { class: "header" }
const _hoisted_14 = { class: "d-flex justify-center" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { key: 1 }
const _hoisted_18 = { key: 2 }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "0 EUR", -1))
const _hoisted_20 = [
  _hoisted_19
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AveineInvoiceManagement = _resolveComponent("AveineInvoiceManagement")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_pagination = _resolveComponent("v-pagination")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_v_card, { class: "d-flex flex-column pa-6 px-xl-14 px-lg-12 rounded-lg chart-container" }, {
          default: _withCtx(() => [
            _createElementVNode("h2", null, _toDisplayString(_ctx.$t("aveine-space.title.page.myInvoices")), 1),
            (_ctx.invoices.length)
              ? (_openBlock(), _createBlock(_component_AveineInvoiceManagement, {
                  key: 0,
                  APIbaseURL: _ctx.APIbaseURL,
                  invoices: _ctx.invoices
                }, null, 8, ["APIbaseURL", "invoices"]))
              : (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, [
                    _createVNode(_component_v_icon, {
                      class: "ma-8",
                      color: "primary",
                      size: "128"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("mdi-close-octagon-outline")
                      ], undefined, true),
                      _: 1
                    })
                  ]),
                  _createElementVNode("span", null, _toDisplayString(_ctx.$t("aveine-invoice.title.noInvoice")), 1)
                ])),
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_v_pagination, {
                modelValue: _ctx.currentPage,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.currentPage) = $event)),
                length: _ctx.paginationLength,
                "total-visible": _ctx.paginationLength < 7 ? _ctx.paginationLength : 7
              }, null, 8, ["modelValue", "length", "total-visible"])
            ])
          ], undefined, true),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          (_ctx.$auth.ambassador)
            ? (_openBlock(), _createBlock(_component_v_card, {
                key: 0,
                class: "py-6 px-xl-14 px-lg-12 px-4 rounded-lg discount-code-card"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("h4", null, _toDisplayString(_ctx.$t("aveine-space.sales.unlockedMoney")), 1),
                  (_ctx.invoiceSummary['amount-unlocked-euro'] || _ctx.invoiceSummary['amount-unlocked-dollar'])
                    ? (_openBlock(), _createElementBlock("span", _hoisted_10, [
                        _createElementVNode("h1", null, _toDisplayString(_ctx.invoiceSummary["amount-unlocked-euro"] ? _ctx.invoiceSummary["amount-unlocked-euro"] + " EUR" : _ctx.invoiceSummary["amount-unlocked-dollar"] + " USD"), 1),
                        _createElementVNode("i", null, "(" + _toDisplayString(_ctx.$t("aveine-space.title.taxIncluded")) + ")", 1)
                      ]))
                    : (_openBlock(), _createElementBlock("h1", _hoisted_11, "0 EUR")),
                  (_ctx.invoiceSummary['amount-unlocked-euro'] || _ctx.invoiceSummary['amount-unlocked-dollar'])
                    ? (_openBlock(), _createBlock(_component_v_btn, {
                        key: 2,
                        class: "my-5",
                        "rounded-lg": "",
                        color: "primary",
                        variant: "flat",
                        to: { name:'InvoiceCreate', params: {id: _ctx.$auth.ambassador.id} }
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t("aveine-space.title.declare")), 1)
                        ], undefined, true),
                        _: 1
                      }, 8, ["to"]))
                    : _createCommentVNode("", true)
                ], undefined, true),
                _: 1
              }))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, [
            (_ctx.$auth.ambassador)
              ? (_openBlock(), _createBlock(_component_v_card, {
                  key: 0,
                  class: "py-6 px-xl-14 px-lg-12 px-4 rounded-lg discount-code-card"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", null, [
                      _createVNode(_component_v_tooltip, { location: "top" }, {
                        activator: _withCtx(({ props }) => [
                          _createElementVNode("div", _mergeProps(props, { class: "mb-2 d-flex align-center" }), [
                            _createElementVNode("h4", null, _toDisplayString(_ctx.$t("aveine-space.sales.lockedMoney")), 1),
                            _createVNode(_component_v_icon, { size: "small" }, {
                              default: _withCtx(() => [
                                _createTextVNode(" mdi-help ")
                              ], undefined, true),
                              _: 1
                            })
                          ], 16)
                        ]),
                        default: _withCtx(() => [
                          _createElementVNode("span", null, _toDisplayString(_ctx.$t("aveine-invoice.tooltip.moneyAvailable")), 1),
                          _createTextVNode(),
                          _hoisted_15,
                          _createElementVNode("span", null, _toDisplayString(_ctx.$t("aveine-invoice.tooltip.moneyLocked")), 1)
                        ], undefined, true),
                        _: 1
                      })
                    ]),
                    (_ctx.invoiceSummary['amount-locked-euro'] || _ctx.invoiceSummary['amount-locked-dollar'])
                      ? (_openBlock(), _createElementBlock("span", _hoisted_16, [
                          _createElementVNode("h1", null, _toDisplayString(_ctx.invoiceSummary["amount-locked-euro"] ? _ctx.invoiceSummary["amount-locked-euro"] + " EUR" : _ctx.invoiceSummary["amount-locked-dollar"] + " USD"), 1),
                          _createElementVNode("i", null, "(" + _toDisplayString(_ctx.$t("aveine-space.title.taxIncluded")) + ")", 1)
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.invoiceSummary['amount-locked-euro'] || _ctx.invoiceSummary['amount-locked-dollar'])
                      ? (_openBlock(), _createElementBlock("i", _hoisted_17, "(" + _toDisplayString(_ctx.$t("aveine-space.sales.unlockedAt")) + " " + _toDisplayString(new Date(_ctx.invoiceSummary["will-unlock-at"]).toLocaleDateString("fr-FR")) + ")", 1))
                      : (_openBlock(), _createElementBlock("span", _hoisted_18, _hoisted_20))
                  ], undefined, true),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ])
  ]))
}